import axios from 'axios';

import { ACCOUNTS_API_ENDPOINT } from 'constants/api';

const accountsAPI = axios.create({
  baseURL: ACCOUNTS_API_ENDPOINT,
});

export default accountsAPI;
